import { useDispatch, useSelector } from 'react-redux';
import { dialogShow } from '../modules/editor';
import AlertModule from '../lib/Alert';
import { RootState } from '../modules';

const useAlert = () => {
	const dispatch = useDispatch();

	const msg = useSelector((state: RootState) => state.editor.service.msg);

	const Alert = {
		...AlertModule,
		msg: msg,
		confirm(msg: string, callback: any, item?: any) {
			dispatch(dialogShow({msg:msg, callback: callback, msgsub: item?.msgsub}));
		}
	}

	return Alert;
}

export default useAlert;